module.exports = __webpack_public_path__ + "assets/images/6ba352a727a6e6b13079008f812cb08a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/freestyle2022.jpg
// module id = 413
// module chunks = 0